export default function lightbox() {
    return {
        init() {
            const elements = document.querySelectorAll('[data-lightbox]');
            [...elements].forEach(el => {
                el.addEventListener('click', () => {
                    this.openLightbox(
                        el.getAttribute('url') ?? '',
                        el.getAttribute('alt') ?? ''
                    );
                })
            })
        },

        openLightbox(src, alt) {
            this.$store.app.lightboxImage = src
            this.$store.app.lightboxImageAlt = alt
        },

        closeLightbox() {
            this.$store.app.lightboxImage = ''
            this.$store.app.lightboxImageAlt = ''
        }
    };
}
